/**
 * "A new version is available" - the strip shown once the app has been
 * deployed since this tab loaded (`state/app-build.ts`). It wears the info
 * announcement strip so it reads as one of them, but nobody writes it: the
 * deploy does. Reload is the user's call, never automatic - a tab may hold
 * unsaved dashboard edits, and those still get the browser's leave prompt.
 */

import { html, nothing, type TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LightElement } from '../../lit-base.ts';
import { StoreController } from '../../state/controller.ts';
import { newBuildAvailable } from '../../state/app-build.ts';
import { toneIcon } from './announcements.ts';

@customElement('app-update-strip')
export class AppUpdateStrip extends LightElement {
  private store = new StoreController(this, [newBuildAvailable]);

  override render(): TemplateResult | typeof nothing {
    if (!newBuildAvailable.value) return nothing;
    return html`<div class="ann-strip tone-info" role="status">
      <span class="ann-strip-icon">${toneIcon('info', 16)}</span>
      <span class="ann-strip-title">A new version of Data Explorer is available.</span>
      <span class="ann-strip-body">Reload to use it - this page is running the previous one.</span>
      <span class="ann-strip-end">
        <button type="button" class="ann-strip-link" @click=${() => window.location.reload()}>Reload</button>
      </span>
    </div>`;
  }
}
